<template>
  <div class="va-row">
    <div class="flex md12 xs12">
      <vuestic-widget>
        <div class="va-row">
          <div class="flex md4">
            <div class="select-title">{{ $t("t.app") }}</div>
            <el-select filterable v-model="value_app" placeholder="">
              <el-option
                v-for="item in appList"
                :key="item.id"
                :value="item.id"
                :label="item.name"
              ></el-option>
            </el-select>
          </div>
          <div class="flex md4">
            <div class="select-title">{{ $t("t.orderCurrency") }}</div>
            <el-select filterable v-model="value_order_currency">
              <el-option :label="$t('basic.select.all')" value="" selected />
              <el-option
                v-for="(val, index) in currencyList"
                :key="index"
                :label="val"
                :value="val"
              >
              </el-option>
            </el-select>
          </div>
          <!-- <div class="flex md4">
            <div class="select-title">{{ $t("t.payCurrency") }}</div>
            <el-select filterable v-model="value_pay_currency">
              <el-option label="ALL" value="" selected />
              <el-option
                v-for="(val, index) in currencyList"
                :key="index"
                :label="val"
                :value="val"
              >
              </el-option>
            </el-select>
          </div> -->
          <div class="flex md4">
            <div class="select-title">{{ $t("t.region") }}</div>
            <el-select filterable v-model="value_region">
              <el-option :label="$t('basic.select.all')" value="" selected />
              <el-option
                v-for="(val, index) in regionList"
                :key="index"
                :label="val.label"
                :value="val.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="va-row">
          <div class="flex md4">
            <div class="select-title">{{ $t("t.method") }}</div>
            <el-select filterable v-model="value_method">
              <el-option :label="$t('basic.select.all')" value="" selected />
              <el-option
                v-for="(item, index) in methodList"
                :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
          <div class="flex md4">
            <div class="select-title">{{ $t("t.status") }}</div>
            <el-select filterable v-model="value_status">
              <el-option :label="$t('basic.select.all')" value="" selected />
              <el-option
                v-for="item in statusList"
                :key="item.code"
                :label="item.desc"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </div>
          <div class="flex md4">
            <div class="select-title">{{ $t("t.dateMode") }}</div>
            <el-select filterable v-model="value_time">
              <el-option
                v-for="(tvalue, name, index) in timeModeList"
                :key="index"
                :label="name"
                :value="tvalue"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="va-row">
          <div class="flex md4">
            <div class="select-title">{{ $t("t.timeZone") }}</div>
            <el-select filterable v-model="currTimeZone">
              <el-option
                v-for="item in timeZoneList"
                :value="item"
                :key="item"
                :label="item"
              >
              </el-option>
            </el-select>
          </div>
          <div class="flex md4">
            <div class="select-title">{{ $t("t.dateRange") }}</div>
            <el-date-picker
              v-model="dateVals"
              style="width: 100% !important"
              type="daterange"
              :picker-options="pickerOptions"
              unlink-panels
              range-separator="-"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              @focus="limitNextDay"
              :default-time="['00:00:00', '23:59:59']"
              start-placeholder="start"
              end-placeholder="end"
            >
            </el-date-picker>
          </div>
          <div class="flex md4">
            <div class="select-title">{{ $t("t.fileType") }}</div>
            <el-select filterable v-model="file_type">
              <el-option
                v-for="(mvalue, name, index) in fileTypeOptions"
                :key="index"
                :label="name"
                :value="mvalue"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="va-row">
          <div class="flex md4">
            <div class="select-title">{{ $t("t.searchMode") }}</div>
            <el-select filterable v-model="value_mode">
              <el-option
                v-for="(mvalue, name, index) in modeList"
                :key="index"
                :label="name"
                :value="mvalue"
              >
              </el-option>
            </el-select>
          </div>
          <div class="flex md4">
            <div class="select-title">{{ $t("t.searchKey") }}</div>
            <el-input v-model="searchVal" clearable></el-input>
          </div>
        </div>
        <div class="va-row" style="justify-content: center;">
          <div class="flex mobile-btn mt-2">
            <button class="btn btn-primary btn-micro" @click="searchOrder">
              <div class="btn-with-icon-content">
                <i class="ion-md-search ion"></i>
                {{ "basic.button.search" | translate }}
              </div>
            </button>
          </div>
          <div class="flex mobile-btn mt-2" v-if="permissions['Download']">
            <button class="btn btn-info btn-micro" @click="downloadOrders">
              <div class="btn-with-icon-content">
                <i class="ion-md-download ion"></i>
                {{ "basic.button.download" | translate }}
              </div>
            </button>
          </div>
          <div class="flex mobile-btn mt-2">
            <button class="btn btn-info btn-micro" @click="popCreateOrderWin">
              <div class="btn-with-icon-content" style="max-width:fit-content;">
                <i class="vuestic-icon vuestic-icon-files ion"></i>
                <b>{{ "basic.button.createOrder" | translate }}</b>
              </div>
            </button>
          </div>
        </div>
        <br />
      </vuestic-widget>
    </div>

    <div class="flex xs12 md12 w-table">
      <vuestic-widget id="dategridPayOrder">
        <!-- table-fileds-settings -->
        <!-- <table-fileds-settings
        :filedsOptions="tableColumns"
        @onRefetchTableColumns="refetchTableColumns"
      ></table-fileds-settings> -->
        <div class="table-responsive mb-0">
          <table class="table table-striped first-td-padding">
            <thead>
              <tr>
                <th v-for="(item, index) in tableHeaderList" :key="index">
                  {{ item.label | translate }}
                </th>

                <!-- <th>{{'tables.listing.merchantReference' | translate}}</th>
              <th>{{'tables.listing.appName' | translate}}</th>
              <th>{{'tables.listing.referenceDateTime' | translate}}</th>
              <th>{{'tables.listing.method' | translate}}</th>
              <th>{{'tables.listing.amount' | translate}}</th>
              <th align="right">{{'tables.listing.status' | translate}}</th>
              <th>{{'tables.listing.muid' | translate}}</th>
              <th>{{'tables.listing.email' | translate}}</th>
              <th>{{'tables.listing.subject' | translate}}</th>
              <th>{{'tables.listing.updateTime' | translate}}</th> -->
              </tr>
            </thead>
            <tbody v-if="list && list.length > 0">
              <tr v-for="(item, index) in list" :key="index">
                <td v-show="showColumnsList.transactionId">
                  <span @click="fetchDetails(item.trade_no)"
                    ><a href="javascript:void(0);" class="alink">{{
                      item.trade_no
                    }}</a></span
                  >
                </td>
                <td v-show="showColumnsList.merchantReference">
                  <span class="action-color-1">{{ item.out_trade_no }}</span>
                </td>
                <td v-show="showColumnsList.appName">{{ item.app_name }}</td>
                <td v-show="showColumnsList.referenceDateTime">
                  {{ dateFormat(item.create_time) }}
                </td>
                <td v-show="showColumnsList.method">
                  {{
                    item.method == undefined || item.method == ""
                      ? "N/A"
                      : item.method
                  }}
                </td>
                <td v-show="showColumnsList.channel">
                  {{
                    item.channel_name == undefined || item.channel_name == ""
                      ? "N/A"
                      : item.channel_name
                  }}
                </td>
                <td v-show="showColumnsList.amount">
                  {{ item.order_currency }} {{ item.order_amount }}
                </td>
                <td align="right" v-show="showColumnsList.status">
                  <el-tag
                    effect="dark"
                    disable-transitions
                    :type="getStatusColor(item.trade_status)"
                    >{{ item.trade_status }}</el-tag
                  >
                </td>
                <td v-show="showColumnsList.muid">
                  {{
                    item.out_uid == undefined || item.out_uid == ""
                      ? "N/A"
                      : item.out_uid
                  }}
                </td>
                <td v-show="showColumnsList.email">
                  {{
                    item.email == undefined || item.email == ""
                      ? "N/A"
                      : item.email
                  }}
                </td>
                <td v-show="showColumnsList.subject">
                  {{
                    item.subject == undefined || item.subject == ""
                      ? "N/A"
                      : item.subject
                  }}
                </td>
                <td v-show="showColumnsList.updateTime">
                  {{ item.update_time ? dateFormat(item.update_time) : "" }}
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="11" v-text="$t('t.noDataNoOrder')"></td>
              </tr>
            </tbody>
          </table>
          <!-- 展示currency -->
          <div class="table-responsive mb-0 mt-3" v-if="tableOrderHeader.length > 0">
            <table class="table table-striped first-td-padding">
              <thead>
                <tr>
                  <th v-for="(item, index) in tableOrderHeader" :key="index">
                    {{ item | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in tableOrderList" :key="i">
                  <td v-for="(key, j) in tableOrderHeader" :key="j">
                    {{ item[key] }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="block" v-if="isMobile === 'pc'">
          <pagination
            v-show="total > 0"
            :total="total"
            :page-size="limit"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :page.sync="page"
            :limit.sync="limit"
            @pagination="orderData"
          />
        </div>
        <div class="block" v-else>
          <pagination
            v-show="total > 0"
            :total="total"
            layout="total, prev, pager, next"
            background
            :page.sync="page"
            :limit.sync="limit"
            @pagination="orderData"
          />
        </div>
      </vuestic-widget>
    </div>
    <el-dialog
      :title="$t('menu.paymentOrderDetails2')"
      id="paymentDetails"
      :visible.sync="dialogTableVisible"
      style="padding-top: 3vh"
      @close="initRefund"
    >
      <div>
        <div class="va-row">
          <div class="flex xs12 md12 w-table">
            <vuestic-widget :headerText="$t('tables.details')">
              <div class="table-responsive" id="details">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>
                        {{ "tables.detailsInfo.transactionID" | translate }}
                      </th>
                      <th>{{ "tables.detailsInfo.amount" | translate }}</th>
                      <th v-if="isPartialPay">{{ "tables.detailsInfo.receivedAmount" | translate }}</th>
                      <th>{{ "tables.detailsInfo.prodDesc" | translate }}</th>
                      <th>{{ "tables.detailsInfo.method" | translate }}</th>
                      <th>{{ "tables.detailsInfo.Status" | translate }}</th>
                      <th>{{ "tables.detailsInfo.createDate" | translate }}</th>
                      <th>{{'tables.detailsInfo.partnerID' | translate}}</th>
                      <!-- <th>{{'tables.detailsInfo.cbStatus' | translate}}</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(val, index) in detailInfo" :key="index">
                      <td
                        v-for="(item, i) in val"
                        :key="i"
                        :style="centerText"
                      >
                        <span v-if="canRefundMethod && item === 'Refund'">
                          <button
                            v-if="!!paymentOrderData.support_refund"
                            class="btn btn-danger btn-micro"
                            :disabled="!refundCanDo"
                            :class="{ disable: !refundCanDo }"
                            @click="showMediumModal"
                          >
                            {{ item }}
                          </button>
                        </span>

                        <!-- <span v-else-if="(locationHost === 'dashboard-test.${envName}.com' || locationHost === 'localhost:8085') && item === 'Refund-test' && detailInfo[0][3]==='RecurringCreditCard'">
                          <button
                            class="btn btn-danger btn-micro"
                            @click="showMediumModal"
                          >
                            Refund+
                          </button>
                        </span> -->
                        <span v-else-if="item === 'Callback'">
                          <button
                            class="btn btn-info btn-micro"
                            @click="callbackOrderStatus"
                            :disabled="isLoading"
                          >
                            {{ isLoading ? "" : "callback" }}
                            <span v-if="isLoading">{{ $t("loading") }}</span>
                          </button>
                        </span>
                        <span v-else-if="item === 'Match Status'">
                          <button
                            class="btn btn-info btn-micro"
                            @click="showModalFillOrder"
                            v-if="locationHost === `dashboard-test.${envName}.com` || locationHost === 'localhost:8001'"
                          >
                            {{ item }}
                          </button>
                        </span>
                        <!-- <span v-else-if="item === 'Refund-test'"></span> -->
                        <span v-else>
                          {{ item }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="block"></div>
            </vuestic-widget>
          </div>
        </div>

        <div class="va-row" v-if="paymentOrderData.detail">
          <div class="flex xs12 md12">
            <vuestic-widget :headerText="$t('tables.statusHis')">
              <div class="table-responsive">
                <table class="table table-striped first-td-padding">
                  <thead>
                    <tr>
                      <th>{{ "tables.statusHisInfo.status" | translate }}</th>
                      <th>{{ "tables.statusHisInfo.date" | translate }}</th>
                      <th>{{ "tables.statusHisInfo.amount" | translate }}</th>
                      <th>{{ "tables.detailsInfo.cbStatus" | translate }}</th>
                      <th>{{ "tables.usering.actions" | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, idx) in paymentOrderData.detail.trans_logs" :key="idx">
                      <td>{{ item.newLogStatus }}</td>
                      <td>{{ item.newCreateTime }}</td>
                      <td>{{ item.refundMoney }}</td>
                      <td>{{ item.logCallbackStatus }}</td>
                      <td v-if="isProviderDelbank">
                        <button class="btn btn-primary btn-micro" @click="downloadDelbankPdfSuccess(item)" v-if="item.newLogStatus === 'Success' && !!paymentOrderData.channel_info">
                          <div class="btn-with-icon-content">
                            <i class="ion-md-download"></i>
                          </div>
                        </button>
                        <button class="btn btn-primary btn-micro" @click="downloadDelbankPdfRefund(item)" v-if="isShowRefundDownload && item.type === 'Refund' && item.log_status === 'Refunded'">
                          <div class="btn-with-icon-content">
                            <i class="ion-md-download"></i>
                          </div>
                        </button>
                      </td>
                      <td v-else-if="!isProviderDelbank && item.type === 'Refund' && item.log_status === 'Refunded'">
                        <button v-if="paymentOrderData.detail.trans_base.method.toLowerCase() === 'pix'" class="btn btn-primary btn-micro" @click="handleDownloadPdf(item)">
                          <div class="btn-with-icon-content">
                            <i class="ion-md-download"></i>
                          </div>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </vuestic-widget>
          </div>
        </div>

        <div class="va-row">
          <div class="flex xs12 md6">
            <vuestic-widget :headerText="$t('tables.buyer')">
              <div class="table-responsive">
                <table class="table table-striped first-td-padding">
                  <tbody>
                    <tr
                      v-for="(bitem, bindex) in buyerInfo"
                      :key="bindex"
                      style="text-align: left"
                    >
                      <td
                        :style="sizeLeft"
                        v-for="(bval, bid) in bitem"
                        :key="bid"
                        v-if="hideBuyerTd(bid)"
                      >
                        <span
                          :class="spanWrapper"
                          v-html="
                            getVerticalTabTd(
                              bval,
                              bid,
                              'buyer',
                              Object.keys(bitem).indexOf(bid),
                              bindex
                            )
                          "
                        ></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </vuestic-widget>
          </div>
          <div class="flex xs12 md6">
            <vuestic-widget :headerText="$t('tables.merchant')">
              <div class="table-responsive" id="merchant">
                <table class="table table-striped first-td-padding">
                  <tbody>
                    <tr
                      v-for="(mitem, mkey) in merchantInfo"
                      :key="mkey"
                      style="text-align: left"
                    >
                      <td :style="sizeLeft">
                        <span
                          :class="spanWrapper"
                          v-html="getVerticalTabTd(mkey, mitem, 'merchant')"
                        ></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </vuestic-widget>
          </div>
        </div>
        <div class="va-row" v-if="transactionInfo.length > 0">
          <div class="flex xs12 md6">
            <vuestic-widget :headerText="$t('tables.transactionCost')">
              <div class="table-responsive" id="transCoat">
                <table class="table table-striped first-td-padding">
                  <thead>
                    <tr>
                      <th>
                        {{ "tables.transactionDetails.option" | translate }}
                      </th>
                      <th>
                        {{ "tables.transactionDetails.setting" | translate }}
                      </th>
                      <th>{{ "tables.transactionDetails.fee" | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(titem, idx) in transactionInfo" :key="idx">
                      <td v-for="(list, t) in titem" :key="t">
                        <span v-html="list"></span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </vuestic-widget>
          </div>
        </div>
        <div class="va-row" v-if="depositUpload.uploadUrl">
          <div class="flex xs12 md6">
            <vuestic-widget :headerText="$t('tables.voucher')">
              <div class="deposit-upload" id="depositUpload">
                <ul style="width: 70%">
                  <li
                    class="oneline-voucher"
                    v-for="(item, index) in payVouchers"
                    :key="index"
                  >
                    <span class="key col-md-5" v-text="item.name"></span>
                    <span class="key col-md-5" v-text="item.time"></span>
                    <a
                      v-if="item.url"
                      :href="item.url"
                      @click="downloadAttachment(item, $event)"
                      class="iconicstroke iconicstroke-download"
                      style="font-size: 24px; cursor: pointer"
                    ></a
                    ><!-- TODO 下载的图标 -->
                  </li>
                </ul>
                <a
                  :href="depositUpload.uploadUrl"
                  target="_blank"
                  class="btn btn-primary btn-micro pull-right"
                  >{{ $t("basic.button.upload") }}</a
                >
              </div>
            </vuestic-widget>
          </div>
        </div>
        <div class="va-row" v-if="refusedFg">
          <div class="flex xs12 md6">
            <vuestic-widget :headerText="$t('tables.antiFraud')">
              <div class="refused-info">
                <ul style="width: 70%">
                  <li class="oneline-voucher">
                    <span>{{ $t("tables.refusedInfo") }}</span>
                    <span v-text="refusedInfo"></span>
                  </li>
                </ul>
              </div>
            </vuestic-widget>
          </div>
          <div class="flex xs12 md6">
            <vuestic-widget :headerText="$t('tables.paymentResponse')">
              <div class="refused-info">
                <ul style="width: 70%">
                  <li class="oneline-voucher">
                    <span>{{ $t("tables.code") }}</span>
                    <span v-text="refusalCode" :style="sizeLeft"></span>
                  </li>
                  <li class="oneline-voucher">
                    <span>{{ $t("tables.message") }}</span>
                    <span v-text="refusalMsg" :style="sizeLeft"></span>
                  </li>
                </ul>
              </div>
            </vuestic-widget>
          </div>
        </div>
      </div>
      <div class="modals-page" id="refundReason">
        <vuestic-order-modal
          :show.sync="show"
          ref="mediumModal"
          :okText="'modal.confirm2' | translate"
          style="height: 100%; width: 60vw"
          :okClass="'btn btn-primary btn-micro'"
          :cancelClass="'btn btn-secondary btn-micro'"
          :cancelText="'modal.cancel2' | translate"
          @cancel="handleModalClose"
        >
          <div slot="title">{{ "modal.refundReason" | translate }}</div>
          <div>
            <form>
              <div class="va-row">
                <div class="flex xs12 md12">
                  <fieldset>
                    <div
                      class="form-group with-icon-right"
                      :class="{
                        'has-error': errors.has('refundAmount'),
                        valid: isFormFieldValid('refundAmount'),
                      }"
                    >
                      <div class="input-group">
                        <!-- onkeyup="value=value.replace(/[^0-9.]+/g,'')"
                        onkeydown="value=value.replace(/[^0-9.]+/g,'')" -->
                        <input
                          id="simple-input"
                          name="refundAmount"
                          data-vv-as="refundAmount"
                          v-model="refundAmount"
                          v-validate="'required|verifyRefundAmount'"
                          autocomplete="off"
                          required
                          oninput="value=value.replace(/[^0-9.]+/g,'')"
                          :disabled="!paymentOrderData.support_partial_refund"
                        />
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i class="fa fa-check valid-icon icon-right input-icon"></i>
                        <label class="control-label" for="simple-input" :style="!paymentOrderData.support_partial_refund ? 'font-size: 0.6rem; color: #4ae387; text-transform: uppercase; top: -0.6rem;':''">
                          {{ "forms.inputs.refundAmount" | translate }}：
                        </label>
                        <i class="bar"></i>
                        <small
                          v-show="errors.has('refundAmount')"
                          class="help text-danger"
                        >
                          {{ errors.first("refundAmount") }}
                        </small>
                      </div>
                    </div>
                    <div
                      v-if="isShowRefundPhoneNumber"
                      class="form-group with-icon-right"
                      :class="{'has-error': errors.has('refundTelephone'), 'valid': isFormFieldValid('refundTelephone')}">
                      <div class="input-group">
                        <input id="refundTelephone"
                              name="refundTelephone"
                              data-vv-as="Phone Number"
                              v-model="refundTelephone"
                              maxlength="128"
                              autocomplete="off"
                              v-validate="'required|verifyCellPhone'"
                              required />
                        <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                        <i class="fa fa-check valid-icon icon-right input-icon"></i>
                        <label class="control-label"
                              for="refundTelephone">Phone Number：</label>
                        <i class="bar"></i>
                        <small v-show="errors.has('refundTelephone')"
                              class="help text-danger">{{ errors.first('refundTelephone') }}</small>
                      </div>
                    </div>
                    <!-- -- {{ detailInfo[0][3] }} -- {{ isRefundMethodPix }} -->
                    <div
                      v-if="isShowRefundEmail"
                      class="form-group with-icon-right"
                      :class="{
                        'has-error': errors.has('successfulEmail'),
                        valid: isSuccessfulEmailValid,
                      }"
                    >
                      <div class="input-group">
                        <input
                          v-if="isRefundMethodPix"
                          id="successfulEmail"
                          name="successfulEmail"
                          v-model="successfulEmail"
                          autocomplete="off"
                          v-validate="'email'"
                        />
                        <input
                          v-else
                          id="successfulEmail"
                          name="successfulEmail"
                          v-model="successfulEmail"
                          autocomplete="off"
                          v-validate="'required|email'"
                          required
                        />
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <label class="control-label" for="successfulEmail">
                          {{ "forms.inputs.buyerEmail" | translate }}：
                        </label>
                        <i class="bar" />
                        <small
                          v-show="errors.has('successfulEmail')"
                          class="help text-danger"
                        >
                          {{ errors.first("successfulEmail") }}
                        </small>
                      </div>
                    </div>

                    <div
                      class="form-group with-icon-right"
                      :class="{
                        'has-error': errors.has('refundExplain'),
                        valid: isFormFieldValid('refundExplain'),
                      }"
                    >
                      <div class="flex md12 xs12" id="textareawrapper">
                        <div class="input-group">
                          <textarea
                            type="text"
                            name="refundExplain"
                            data-vv-as="Name"
                            id="simple-textarea"
                            v-model="refundExplain"
                            :placeholder="$t('payment.upTo100Characters')"
                            maxlength="100"
                            rows="2"
                            :style="paddTop"
                            @focus="resizeLabel"
                            @blur="focusLabel"
                            v-validate="'required'"
                            required
                          >
                          </textarea>
                          <i
                            class="
                              fa fa-exclamation-triangle
                              error-icon
                              icon-right
                              input-icon
                            "
                          ></i>
                          <i
                            class="fa fa-check valid-icon icon-right input-icon"
                          ></i>
                          <label class="control-label" for="simple-textarea"
                            >{{
                              "forms.inputs.description" | translate
                            }}：</label
                          ><i class="bar"></i>
                          <small
                            v-show="errors.has('refundExplain')"
                            class="help text-danger"
                          >
                            {{ errors.first("refundExplain") }}
                          </small>
                        </div>
                      </div>
                    </div>
                    <div
                      class="form-group with-icon-right"
                      v-if="speiFlag"
                      :class="{
                        'has-error': errors.has('bank'),
                        valid: isFormFieldValid('bank'),
                      }"
                    >
                      <div class="input-group">
                        <el-select
                          id="bank"
                          name="bank"
                          v-model="bankCode"
                          :filterable="true"
                          v-validate="'required'"
                          required
                          :placeholder="$t('payment.pleaseSelectABank')"
                          @change="selectBankCode"
                        >
                          <el-option
                            v-for="item in bankCodeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <i class="bar" />
                        <small
                          v-show="errors.has('bank')"
                          class="help text-danger"
                        >
                          {{ errors.first("bank") }}
                        </small>
                      </div>
                    </div>
                    <div
                      class="form-group with-icon-right"
                      v-if="speiFlag"
                      :class="{
                        'has-error': errors.has('clabe'),
                        valid: isFormFieldValid('clabe'),
                      }"
                    >
                      <div class="input-group">
                        <input
                          id="clabe"
                          name="clabe"
                          v-model="clabe"
                          v-validate="'required|verifyClabe'"
                          autocomplete="off"
                          required
                        />
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <label class="control-label" for="clabe">
                          CLABE：
                        </label>
                        <i class="bar" />
                        <small
                          v-show="errors.has('clabe')"
                          class="help text-danger"
                        >
                          {{ errors.first("clabe") }}
                        </small>
                      </div>
                    </div>
                    <div
                      class="form-group with-icon-right"
                      v-if="speiFlag"
                      :class="{
                        'has-error': errors.has('documentType'),
                        valid: isFormFieldValid('documentType'),
                      }"
                    >
                      <div class="input-group">
                        <el-select
                          id="document_type"
                          name="documentType"
                          v-model="documentType"
                          v-validate="'required'"
                          :placeholder="$t('payment.pleaseSelectADocumentType')"
                          @change="selectDocumentType"
                          required
                        >
                          <el-option
                            v-for="item in documentTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <!-- <label class="control-label" for="document_type">
                          document type：
                        </label> -->
                        <i class="bar" />
                        <small
                          v-show="errors.has('documentType')"
                          class="help text-danger"
                        >
                          {{ errors.first("documentType") }}
                        </small>
                      </div>
                    </div>
                    <div
                      class="form-group with-icon-right"
                      v-if="speiFlag"
                      :class="{
                        'has-error': errors.has('documentId'),
                        valid: isFormFieldValid('documentId'),
                      }"
                    >
                      <div class="input-group">
                        <input
                          id="document_id"
                          name="documentId"
                          v-model="documentId"
                          v-validate="'required|verifyDocumentId'"
                          autocomplete="off"
                          required
                        />
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <label class="control-label" for="document_id">
                          Document id：
                        </label>
                        <i class="bar" />
                        <small
                          v-show="errors.has('documentId')"
                          class="help text-danger"
                        >
                          {{ errors.first("documentId") }}
                        </small>
                      </div>
                    </div>
                    <div
                      class="form-group with-icon-right"
                      v-if="speiFlag"
                      :class="{
                        'has-error': errors.has('Name'),
                        valid: isFormFieldValid('Name'),
                      }"
                    >
                      <div class="input-group">
                        <input
                          id="document_name"
                          name="Name"
                          v-model.trim="documentName"
                          v-validate="'required|verifyName'"
                          autocomplete="off"
                          required
                        />
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <label class="control-label" for="document_name">
                          Name：
                        </label>
                        <i class="bar" />
                        <small
                          v-show="errors.has('Name')"
                          class="help text-danger"
                        >
                          {{ errors.first("Name") }}
                        </small>
                      </div>
                    </div>
                    <!-- 这一块打算添加上对现金支付的申请用的字段 TODO -->
                    <vuestic-checkbox
                      ref="other"
                      v-if="checkManualRefund(detailInfo[0][3]) && !speiFlag && showCheckboxRefund(detailInfo[0][3])"
                      :label="$t('forms.controls.options')"
                      v-model="checkboxOption"
                    />
                    <div id="user_info" class="" v-if="dispalyOtherFg">
                      <div
                        class="form-group with-icon-right"
                        :class="{
                          'has-error': errors.has('username'),
                          valid: isFormFieldValid('username'),
                        }"
                      >
                        <div class="input-group">
                          <input
                            id="uname-input"
                            name="username"
                            data-vv-as="Name"
                            v-model="username"
                            v-validate="'required'"
                            required
                          />
                          <i
                            class="
                              fa fa-exclamation-triangle
                              error-icon
                              icon-right
                              input-icon
                            "
                          ></i>
                          <i
                            class="fa fa-check valid-icon icon-right input-icon"
                          ></i>
                          <label class="control-label" for="uname-input"
                            >{{ "forms.inputs.username" | translate }}：</label
                          ><i class="bar"></i>
                          <small
                            v-show="errors.has('username')"
                            class="help text-danger"
                          >
                            {{ errors.first("username") }}
                          </small>
                        </div>
                      </div>
                      <div
                        class="form-group with-icon-right"
                        :class="{
                          'has-error': errors.has('cpfNO'),
                          valid: isFormFieldValid('cpfNO'),
                        }"
                      >
                        <div class="input-group">
                          <input
                            id="cpfNO-input"
                            name="cpfNO"
                            data-vv-as="Name"
                            v-model="cpfNO"
                            v-validate="'required'"
                            maxlength="14"
                            required
                          />
                          <i
                            class="
                              fa fa-exclamation-triangle
                              error-icon
                              icon-right
                              input-icon
                            "
                          ></i>
                          <i
                            class="fa fa-check valid-icon icon-right input-icon"
                          ></i>
                          <label class="control-label" for="cpfNO-input"
                            >{{ "forms.inputs.cpfNO" | translate }}：</label
                          ><i class="bar"></i>
                          <small
                            v-show="errors.has('cpfNO')"
                            class="help text-danger"
                          >
                            {{ errors.first("cpfNO") }}
                          </small>
                        </div>
                      </div>
                      <div
                        class="form-group with-icon-right"
                        :class="{
                          'has-error': errors.has('agency'),
                          valid: isFormFieldValid('agency'),
                        }"
                      >
                        <div class="input-group">
                          <input
                            id="agency-input"
                            name="agency"
                            data-vv-as="Name"
                            v-model="agency"
                            v-validate="'required'"
                            maxlength="6"
                            onkeyup="this.value=this.value.replace(/[^a-zA-Z0-9\-]/g,'')"
                            ondragenter="return false"
                            ondragover="return false"
                            required
                          />
                          <i
                            class="
                              fa fa-exclamation-triangle
                              error-icon
                              icon-right
                              input-icon
                            "
                          ></i>
                          <i
                            class="fa fa-check valid-icon icon-right input-icon"
                          ></i>
                          <label class="control-label" for="agency-input"
                            >{{ "forms.inputs.agency" | translate }}：</label
                          ><i class="bar"></i>
                          <small
                            v-show="errors.has('agency')"
                            class="help text-danger"
                          >
                            {{ errors.first("agency") }}
                          </small>
                        </div>
                      </div>
                      <div
                        class="form-group with-icon-right"
                        id="bankWrapper"
                        :class="{
                          'has-error': initSelectedVaild,
                          valid: isBankVaild(selBank),
                        }"
                      >
                        <div class="input-group">
                          <vuestic-simple-select
                            :label="$t('forms.inputs.bank')"
                            name="selBank"
                            data-vv-as="Name"
                            v-model="selBank"
                            ref="bankInput"
                            @input="forbiddenInput"
                            autocomplete="off"
                            v-validate="'required'"
                            required
                            option-key="description"
                            v-bind:options="bankOptions"
                          />
                          <i
                            class="
                              fa fa-exclamation-triangle
                              error-icon
                              icon-right
                              input-icon
                            "
                          ></i>
                          <i
                            class="fa fa-check valid-icon icon-right input-icon"
                          ></i>
                          <small
                            v-show="initSelectedVaild"
                            class="help text-danger"
                            style="display: block; margin-top: -30px"
                          >
                            {{ errors.first("selBank") }}
                          </small>
                        </div>
                      </div>
                      <div
                        class="form-group with-icon-right"
                        id="accountWrapper"
                        :class="{
                          'has-error': initSelAccoutTypeVaild,
                          valid: isAccountVaild(accountType),
                        }"
                      >
                        <div class="input-group">
                          <vuestic-simple-select
                            :label="$t('forms.inputs.accountType')"
                            name="accountType"
                            data-vv-as="Name"
                            v-model="accountType"
                            ref="accountInput"
                            @input="forbiddenAccountInput"
                            autocomplete="off"
                            v-validate="'required'"
                            required
                            option-key="description"
                            v-bind:options="accountOptions"
                          />
                          <i
                            class="
                              fa fa-exclamation-triangle
                              error-icon
                              icon-right
                              input-icon
                            "
                          ></i>
                          <i
                            class="fa fa-check valid-icon icon-right input-icon"
                          ></i>
                          <small
                            v-show="initSelAccoutTypeVaild"
                            class="help text-danger"
                            style="display: block; margin-top: -30px"
                          >
                            {{ errors.first("accountType") }}
                          </small>
                        </div>
                      </div>
                      <div class="form-group with-icon-right">
                        <div class="input-group">
                          <input
                            id="card_number"
                            name="card_number"
                            data-vv-as="Name"
                            v-model="bankAccountNumberFirst"
                            v-validate="'required'"
                            style="display: inline-block; width: 60%"
                            onpaste="return false"
                            ondragenter="return false"
                            ondragover="return false"
                            maxlength="14"
                            @focus="formatCardNumber($event)"
                            required
                          />
                          <span>—</span>
                          <input
                            id="branch_num"
                            name="branch_num"
                            data-vv-as="Name"
                            v-model="bankAccountNumberLast"
                            v-validate="'required'"
                            style="
                              display: inline-block;
                              width: 20%;
                              padding-left: 10px;
                            "
                            maxlength="2"
                            onkeyup="this.value=this.value.replace(/\D/g,'')"
                            onkeydown="this.value=this.value.replace(/\D/g,'')"
                            onpaste="return false"
                            ondragenter="return false"
                            ondragover="return false"
                            required
                          />
                          <i
                            class="
                              fa fa-exclamation-triangle
                              error-icon
                              icon-right
                              input-icon
                            "
                          ></i>
                          <i
                            class="fa fa-check valid-icon icon-right input-icon"
                          ></i>
                          <label class="control-label" for="card_number"
                            >{{
                              "forms.inputs.bankAccountNumber" | translate
                            }}：</label
                          ><i class="bar"></i>
                        </div>
                      </div>
                    </div>
                    <div
                      class="form-group with-icon-right"
                      :class="{
                        'has-error': errors.has('userPass'),
                        valid: isFormFieldValid('userPass'),
                      }"
                    >
                      <div class="input-group">
                        <input
                          id="password"
                          name="userPass"
                          data-vv-as="Password"
                          type="password"
                          v-model="userPass"
                          v-validate="'required'"
                          required
                          onkeyup="value=value.replace(/\s/g,'')"
                          onkeydown="value=value.replace(/\s/g,'')"
                        />
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <label class="control-label" for="password">
                          {{ $t("auth.password") }}：
                        </label>
                        <i class="bar" />
                        <small
                          v-show="errors.has('userPass')"
                          class="help text-danger"
                          >{{ errors.first("userPass") }}</small
                        >
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </form>
          </div>
        </vuestic-order-modal>
      </div>

      <div class="modals-page" id="fillOrder">
        <vuestic-modal
          :show.sync="show"
          ref="fillOrderModal"
          :okText="'modal.confirm2' | translate"
          class="fill-order-modal"
          :okClass="'btn btn-primary btn-micro'"
          :cancelClass="'btn btn-secondary btn-micro'"
          :cancelText="'modal.cancel2' | translate"
          @cancel="fillOrderModalClose"
        >
          <div slot="title">{{ "modal.fillOrder" | translate }}</div>
          <div>
            <form>
              <div class="va-row">
                <div class="flex xs12 md12">
                  <fieldset>
                    <div
                      class="form-group with-icon-right"
                      :class="{
                        'has-error': errors.has('orderStatus'),
                        valid: isFormFieldValid('orderStatus'),
                      }"
                    >
                      <div class="input-group">
                        <el-select
                          id="orderStatus"
                          name="orderStatus"
                          data-vv-as="status"
                          v-model="fillStatus"
                          :filterable="true"
                          v-validate="'required'"
                          required
                          :placeholder="$t('pleaseSelectStatus')"
                          @change="selectStatusCode"
                        >
                          <el-option
                            v-for="item in statusOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <i class="bar" />
                        <small
                          v-show="errors.has('orderStatus')"
                          class="help text-danger"
                        >
                          {{ errors.first("orderStatus") }}
                        </small>
                      </div>
                    </div>

                    <div
                      class="form-group with-icon-right"
                      :class="{
                        'has-error': errors.has('userPass'),
                        valid: isFormFieldValid('userPass'),
                      }"
                    >
                      <div class="input-group">
                        <input
                          name="userPass"
                          data-vv-as="Password"
                          type="password"
                          id="password"
                          v-model="userPass"
                          v-validate="'required'"
                          required="required"
                          onkeyup="value=value.replace(/\s/g,'')"
                          onkeydown="value=value.replace(/\s/g,'')"
                        />
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <label class="control-label" for="password">
                          {{ $t("auth.password") }}：
                        </label>
                        <i class="bar" />
                        <small
                          v-show="errors.has('userPass')"
                          class="help text-danger"
                          >{{ errors.first("userPass") }}</small
                        >
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </form>
          </div>
        </vuestic-modal>
      </div>

      <div class="flex xs12 md6 flex-center" v-if="isToastContentPresent">
        <div class="toasted-container sample-toasted-container shrink">
          <div class="toasted vuestic-toast none default" style="justify-content: flex-start">
            <i class="fa" :class="toastIcon" v-if="toastIcon" />
            {{ toastText }}
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- create order -->
    <create-order ref="create-order-component" :appList="createOrderAppList" @newPayment="createNewPayment" @close="searchOrder" />
    <!-- pdf render -->
    <render-pdf-dom ref="render-pdf-ref" :refund-voucher="refundVoucher"></render-pdf-dom>
  </div>
</template>

<script>
//  增加详情页面
import {
  request,
  checkMobileOversea,
  formatUserCredentials,
  downloadImage,
  downloadPDF
} from '@/utils/utils.js'
import { translateDetailLabel as mapDetailLabel } from '@/utils/detailLabel.js'
import Scrollbar from '@/vuestic-theme/vuestic-components/vuestic-scrollbar/VuesticScrollbar.vue'

import TableFiledsSettings from '@/package/TableFiledsSettings.vue'

import Pagination from '@/components/Pagination'

import { Dialog } from 'element-ui'
import { findElements } from '@fullcalendar/core'
import RenderPdfDom from '@/components/PaymentOrder/PaymentOrder/RenderPdfDom'
import usePaymentOrder from './PaymentOrder/PaymentOrder'
import usePaymentOrderList from './PaymentOrder/PaymentOrderList'
import CreateOrder from '@/components/PaymentOrder/PaymentOrder/CreateOrderModal'
import pageName from '../NewUser/pageNames'
var moment = require('moment-timezone')
var zoneObj = {}
const validateRfc = require('validate-rfc')
const { bankCodeList, documentTypeList, bankOptions, tzOptions, showColumnsList, tableColumns, tableHeaderList, modeList, timeModeList, timeZoneList, buyerInfo, deviceInfo, merchantInfo, payVouchers, accountOptions, statusOptions } = usePaymentOrder()
const { downloadOrdersImpl, orderDataImpl } = usePaymentOrderList()

export default {
  name: 'PaymentOrder',
  data () {
    this.$validator.extend('verifyCellPhone', {
      validate: (value, ref) => {
        const status = checkMobileOversea(value)
        return status
      },
      getMessage: (field) => 'The ' + field + ' is not valid.'
    })
    this.$validator.extend('verifyRefundAmount', {
      validate: (value, ref) => {
        const reg = /(?!(^[0.]*$))((^[1-9]\d*$)|(?!(^0{2,}.))(?!(^0{1,}[1-9]+))(^[0-9]+.\d{1,2}$))/
        if (!reg.test(value)) {
          return false
        }
        return true
      },
      getMessage: (field) => 'The valid format should be 1234.56'
    })
    this.$validator.extend('verifyClabe', {
      validate: (value, ref) => {
        // 10 - 20 位
        if (value.length < 10 || value.length > 20) {
          return false
        }
        return true
      },
      getMessage: (field) => 'The ' + field + ' must be at least 10 characters, at most 20 characters.'
    })
    this.$validator.extend('verifyDocumentId', {
      validate: (value, ref) => {
        // RFC 和 CURP 规则参考checkout页面 ； ND 最大18位
        // MEX: { RFC: /^([a-zA-Z]{3,4})(\d{6})([a-zA-Z0-9]{3})$/}
        // CURP ND RFC
        const regExpCurp = /^([a-zA-Z]{4}\d{6}[a-zA-Z]{6}[0-9a-zA-Z]{1}\d{1})$/
        const response = validateRfc(value)
        if (!this.documentType) {
          return false
        } else if (this.documentType === 'ND' && value.length > 18) {
          return false
        } else if (this.documentType === 'RFC' && !response.isValid) {
          return false
        } else if (this.documentType === 'CURP' && !regExpCurp.test(value)) {
          return false
        }
        return true
      },
      getMessage: (field) => {
        if (!this.documentType) {
          return 'Please select a document type'
        } else {
          return 'The ' + field + ' is not valid.'
        }
      }

    })
    this.$validator.extend('verifyName', {
      validate: (value, ref) => {
        // 只允许字母
        let regExpName = /^[a-zA-Z ]+$/
        if (!regExpName.test(value)) {
          return false
        }
        return true
      },
      getMessage: (field) => 'The ' + field + ' can be only letters.'
    })
    return {
      fileTypeOptions: {
        'XLSX': 'xlsx',
        'CSV': 'csv'
      },
      file_type: 'xlsx',
      bankCodeList,
      documentTypeList,
      selectedBank: {},
      bankCode: '',
      speiFlag: false,
      isLoading: false,
      tzOptions,
      sctedTableColumns: [],
      showColumnsList,
      tableColumns,
      tableHeaderList,
      list: null, // 请求回来填充表格的数据
      total: 0, // 数据总条数
      page: 1, // 默认显示第1页
      limit: 10, // 默认一次显示10条数据
      appList: '',
      createOrderAppList: [],
      currencyList: '',
      regionList: [],
      methodList: '',
      modeList,
      timeModeList,
      statusList: [],
      value_app: '',
      value_order_currency: '',
      value_pay_currency: '',
      value_region: '',
      value_method: '',
      value_mode: '',
      value_time: '1',
      value_status: '',
      searchVal: '',
      dateVals: [],
      dateDetails: [],
      timeZoneList,
      currTimeZone: 'America/Sao_Paulo',
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() + 24 * 60 * 60 * 1000
        },
      },
      recordTime2country: [],
      changeDateFg: false,
      queryDate: {
        start_time: '',
        end_time: '',
      },

      // 增加详情页面
      dialogTableVisible: false,
      show: true,
      single: [],
      detailInfo: [[], []],
      out_trade_no: '',
      app_id: '',
      statusHistoryInfo: [[]],
      transactionInfo: [
        // ['Transaction Fee Rate Success', '5%', 'BRL 5.00']
      ],
      depositUpload: {
        uploadUrl: '', // 'http://www.baidu.com/'
      },
      buyerInfo,
      deviceInfo,
      merchantInfo,
      spanWrapper: 'span-wrapper',
      verticalTitle: 'vertical-title',
      leftText: {
        textAlign: 'left',
      },
      sizeLeft: {
        display: 'inline-block',
        textAlign: 'left',
        'min-width': '120px',
      },
      rigthText: {
        textAlign: 'right',
      },
      centerText: {
        textAlign: 'center',
      },
      mgr: {
        marginRight: '30px',
      },
      mgr2: {
        marginRight: '60px',
        visibility: 'hidden',
      },
      paddTop: {
        'padding-top': '18px',
      },
      refundAmount: '',
      refundTelephone: '',
      successfulEmail: '',
      clabe: '',
      refundExplain: '',
      userPass: '',
      toastText: 'Application for refund has been submitted!',
      toastIcon: 'fa-star-o',
      toastPosition: 'top-center',
      isToastFullWidth: false,
      toastDuration: 3000,
      isToastContentPresent: false,
      loading: null,
      refundCanDo: true,
      downLoading: null,
      searching: null,
      payVouchers,
      checkboxOption: false,
      username: '',
      cpfNO: '',
      agency: '',
      bankStatus: false,
      selBank: '',
      bankOptions,
      accountType: '',
      aTypeStatus: false,
      accountOptions,
      bankAccountNumberFirst: '',
      bankAccountNumberLast: '',
      dispalyOtherFg: false,
      refusedInfo: 'error',
      refusalCode: '',
      refusalMsg: '',
      refusedFg: false,
      canRefundMethod: '',
      fillStatus: '',
      statusOptions,
      selectedStatus: {},
      locationHost: '',
      documentId: '',
      documentType: '',
      documentName: '',
      currentModalMethod: '',
      paymentOrderData: {},
      refundVoucher: {},
      // 列表下显示币种文案
      tableOrderHeader: [],
      tableOrderList: [],

      isPartialPay: false,
    }
  },
  watch: {
    currTimeZone: function setSepratedRange1 () {
      this.queryDate.start_time = moment
        .tz(moment.tz(this.dateVals[0], this.currTimeZone), 'UTC')
        .format('YYYY-MM-DD HH:mm:ss')
      this.queryDate.end_time = moment
        .tz(moment.tz(this.dateVals[1], this.currTimeZone), 'UTC')
        .format('YYYY-MM-DD HH:mm:ss')
    },
    dateVals: function setSepratedRange (val) {
      let dateOptions = val
      if (!dateOptions) {
        dateOptions = []
        dateOptions.push(moment().subtract(1, 'years').format('YYYY-MM-DD 00:00:00'))
        dateOptions.push(moment().format('YYYY-MM-DD 23:59:59'))
      }
      this.queryDate.start_time = moment
        .tz(moment.tz(dateOptions[0], this.currTimeZone), 'UTC')
        .format('YYYY-MM-DD HH:mm:ss')
      this.queryDate.end_time = moment
        .tz(moment.tz(dateOptions[1], this.currTimeZone), 'UTC')
        .format('YYYY-MM-DD HH:mm:ss')
    },
    checkboxOption: {
      handler: function (newVal, oldVal) {
        if (newVal === true) {
          this.dispalyOtherFg = true
        } else {
          this.dispalyOtherFg = false
        }
      },
      immediate: true,
      deep: true,
    },
    cpfNO: {
      handler: function (newVal, oldVal) {
        if (newVal.length === 4) {
          this.cpfNO = oldVal + '.' + newVal.substring(3)
        }
        if (newVal.length === 8) {
          this.cpfNO = oldVal + '.' + newVal.substring(7)
        }
        if (newVal.length === 12) {
          this.cpfNO = oldVal + '-' + newVal.substring(11)
        }
      },
      immediate: true,
      deep: true,
    },
    bankAccountNumberFirst: {
      handler: function (newVal, oldVal) {
        if (newVal.length === 4) {
          this.bankAccountNumberFirst += ' '
        }
        if (newVal.length === 9) {
          this.bankAccountNumberFirst += ' '
        }
      },
      immediate: true,
      deep: true,
    },
  },
  // 增加详情页面
  computed: {
    isSuccessfulEmailValid () {
      let isValid = false
      if (this.formFields.successfulEmail) {
        isValid =
          this.formFields.successfulEmail.validated &&
          this.formFields.successfulEmail.valid
      }
      return isValid
    },

    isMobile: function () {
      if (document.body.clientWidth && document.body.clientWidth < 750) {
        return 'mobile'
      }
      return 'pc'
    },
    initSelectedVaild () {
      return this.bankStatus
    },
    initSelAccoutTypeVaild () {
      return this.aTypeStatus
    },
    envName () {
      return process.env.VUE_APP_NAME.toLowerCase()
    },
    isRefundMethodPix () {
      if (this.currentModalMethod && this.currentModalMethod.toLowerCase() === 'pix') {
        return true
      }
      return false
    },
    permissions () {
      if (Object.prototype.toString.call(this.$store.getters.user.permissions) === '[object Object]') {
        let storePerm = { ...this.$store.getters.user.permissions }
        const perms = {
          // [pageName.transactions]: false,
          [pageName.report]: false,
          [pageName.appManagement]: false,
          [pageName.finance]: false,
          [pageName.merchantKyc]: false,
          [pageName.userManagement]: false,
          [pageName.wayBill]: false,
          [pageName.recurring]: false,
          [pageName.virtualAccount]: false,
          [pageName.download]: false
        }
        for (let item in storePerm) {
          if (perms[item] !== undefined) {
            perms[item] = !!storePerm[item]
          }
        }
        return perms
      }
      return {}
    },
    isProviderDelbank () {
      if (!this.paymentOrderData.detail) { return }
      return this.paymentOrderData.detail.trans_base.payment_info.provider === 'Delbank'
    },
    isShowRefundDownload () {
      const baseInfo = this.paymentOrderData.detail.trans_base
      if (!baseInfo.trade_status) { return false }
      const refundStatus = ['refused', 'refunded', 'partialrefunded']
      const refundOrder = this.getRefundOrder()
      return !!refundOrder && refundStatus.includes(baseInfo.trade_status.toLowerCase())
    },
    isShowRefundPhoneNumber () {
      if (!this.paymentOrderData.detail) { return }
      const { trans_base = {} } = this.paymentOrderData.detail
      const { channel_name } = trans_base
      const channelNames = [
        'Nequi',
        // 'YooMoney'
      ]
      if (channelNames.includes(channel_name)) {
        return true
      }
      return false
    },
    isShowRefundEmail () {
      if (!this.paymentOrderData.detail) { return true }
      const baseInfo = this.paymentOrderData.detail.trans_base
      const paymentInfo = baseInfo.payment_info
      return (this.detailInfo && this.detailInfo[0] && this.detailInfo[0][3] !== 'SBP' && this.detailInfo[0][3] !== 'SberPay') && !(this.detailInfo[0][3] === 'CreditCard' && paymentInfo.provider && paymentInfo.provider.startsWith('Bank131'))
    }
  },
  created () {
    this.dateVals.push(
      moment().subtract(31, 'days').format('YYYY-MM-DD 00:00:00')
    )
    this.dateVals.push(moment().format('YYYY-MM-DD 23:59:59'))
    // 增加详情页面
    this.$nextTick(() => {
      this.$validator.validateAll()
    })
    this.locationHost = location.host
  },
  async mounted () {
    await this.initDropdown()
    this.initCreateOrderApps()
    window.addEventListener('keyup', this.queryOrder, false)
  },
  methods: {
    handleModalClose () {
      this.clabe = ''
      this.bankCode = ''
    },
    selectBankCode (id) {
      this.selectedBank = this.bankCodeList.find((item) => {
        return item.value === id
      })
    },
    selectDocumentType (id) {
      this.selectedDocumentType = this.documentTypeList.find((item) => {
        return item.value === id
      })
      this.documentId = ''
    },
    fillOrderModalClose () {
      this.fillStatus = ''
      this.userPass = ''
    },
    selectStatusCode (id) {
      this.selectedStatus = this.statusOptions.find((item) => {
        return item.value === id
      })
    },
    getHandleColumn (filterColumns) {
      let exist = {}
      let delColumnsArr = []
      this.tableColumns.forEach((temp, idx) => {
        if (filterColumns.indexOf(temp.key) < 0) {
          temp.id = idx
          delColumnsArr.push(temp)
        }
      })
      if (delColumnsArr.length > 0) {
        delColumnsArr.some((item) => {
          if (
            item.key ==
            this.sctedTableColumns[this.sctedTableColumns.length - 1].key
          ) {
            // 删除当前选中项
            exist = item
            exist.delete = true
          }
        })
      }
      return exist
    },
    refetchTableColumns (selectedcolum, filterColumns) {
      this.sctedTableColumns.push(selectedcolum)
      const handleColumnRes = this.getHandleColumn(filterColumns)
      if (this.tableHeaderList.length > 0) {
        if (handleColumnRes.delete) {
          // 删除
          this.tableHeaderList.some((t, idx) => {
            if (t.id == handleColumnRes.id) {
              this.showColumnsList[t.key] = false
              this.tableHeaderList.splice(idx, 1)
              return true
            }
          })
        } else {
          // 添加
          this.tableHeaderList = this.tableHeaderList.sort(
            (a, b) => a.id - b.id
          )
          if (
            this.tableHeaderList[this.tableHeaderList.length - 1].id <
            selectedcolum.id
          ) {
            this.showColumnsList[selectedcolum.key] = true
            this.tableHeaderList.push(selectedcolum)
          } else {
            this.tableHeaderList.some((col, index) => {
              if (selectedcolum.id < col.id) {
                this.showColumnsList[selectedcolum.key] = true
                this.tableHeaderList.splice(index, 0, selectedcolum)
                return true
              }
            })
          }
        }
      } else {
        // 添加
        let temp = this.sctedTableColumns[this.sctedTableColumns.length - 1]
        delete temp.delete
        this.showColumnsList[temp.key] = true
        this.tableHeaderList.push(temp)
      }
    },
    limitNextDay () {
      if (document.querySelector('.today')) {
        if (document.querySelector('.today').nextSibling.className) {
          document.querySelector('.today').nextSibling.className =
            'normal disabled'
        }
      }
      if (this.isMobile === 'mobile') {
        let datePicker = document.querySelector('.el-date-range-picker')
        if (datePicker) {
          datePicker.style.width = '325px'
          datePicker.style.left = '40px'
          document.querySelector(
            '.el-date-range-picker .el-picker-panel__body'
          ).style.minWidth = '325px'
          document.querySelector(
            '.el-date-range-picker__content.is-left'
          ).style.width = '100%'
          document.querySelector(
            '.el-date-range-picker__content.is-right'
          ).style.width = '100%'
        }
      }
    },
    queryOrder (event) {
      if (event.keyCode === 13) {
        this.searchOrder()
      }
    },
    dateFormat (value) {
      return moment
        .tz(moment.tz(value, 'UTC'), this.currTimeZone)
        .format('YYYY-MM-DD HH:mm:ss')
    },
    formatCardNumber (e) {
      // 格式化银行卡号
      if (e.target.value.length === 4) {
        e.target.value += ' '
      }
      if (e.target.value.length === 9) {
        e.target.value += ' '
      }
      if (e.target.value.length > 14) {
        e.target.value = e.target.value.substring(0, 14)
      }
    },
    loadingFullScreen (controller, txt, className) {
      this[controller] = this.$loading({
        lock: true,
        text: txt,
        spinner: className,
        background: 'rgba(0, 0, 0, 0.7)',
      })
    },
    initDropdown () {
      let token = localStorage.getItem('Authorization')
      let url = '/api/dashboard/basic/getDropdown?access_token=' + token
      request({
        method: 'post',
        url,
      }).then((res) => {
        this.appList = [{ id: '', name: 'All' }].concat(res.data.apps)
        this.value_app = this.appList[0].id
        this.currencyList = res.data.order_currency
        this.regionList = res.data.regions.map(({ code, name }) => { return { label: name, value: code } })
        this.methodList = res.data.method
        this.filterPaiedStatus(res.data.trade_status)
      })
    },
    initCreateOrderApps () {
      let token = localStorage.getItem('Authorization')
      let url = '/api/dashboard/order/available-apps?access_token=' + token
      request({
        method: 'post',
        url,
      }).then((res) => {
        const { status, data = {} } = res
        if (status === 200) {
          const { apps } = data
          this.createOrderAppList = apps.map(app => {
            app.label = `${app.name}(${app.id})`
            return app
          })
        }
      })
    },
    filterPaiedStatus (data) {
      var allStatus = [
        'Refused',
        'Processing',
        'Initial',
        'ChargeBack',
        'ChargebackReversed',
        'Success',
        'Cancelled',
        'Refunded',
        'Dispute',
        'RefundVerifying',
        'RefundProcessing',
        'RiskControl',
        'PartialRefund',
        'OverPaid',
        'PartialPaid'
      ]
      for (let i = 0; i < data.length; i++) {
        if (allStatus.includes(data[i].desc)) {
          this.statusList.push(data[i])
        }
      }
    },
    forbiddenInput (val) {
      if (!val) {
        this.$refs.bankInput.$el.getElementsByTagName('input')[0].style.height =
          '28px'
        this.bankStatus = true
      } else {
        this.bankStatus = false
      }
    },
    forbiddenAccountInput (val) {
      if (!val) {
        this.$refs.accountInput.$el.getElementsByTagName(
          'input'
        )[0].style.height = '28px'
        this.bankStatus = true
      } else {
        this.bankStatus = false
      }
    },
    downFile (blob, fileName) {
      // 非IE下载
      if ('download' in document.createElement('a')) {
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob) // 创建下载的链接
        link.download = fileName // 下载后文件名
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click() // 点击下载
        window.URL.revokeObjectURL(link.href) // 释放掉blob对象
        document.body.removeChild(link) // 下载完成移除元素
      } else {
        // IE10+下载
        window.navigator.msSaveBlob(blob, fileName)
      }
    },
    downloadOrders () {
      downloadOrdersImpl(this)
    },

    searchOrder () {
      this.page = 1
      this.loadingFullScreen('searching', 'Searching', 'fa fa-hourglass-half')
      this.orderData()
    },
    orderData () {
      orderDataImpl(this)
    },
    getStatusColor (status) {
      if (status == 'Success' || status == 'OverPaid' || status == 'PartialPaid') {
        return 'success'
      }
      if (
        status == 'Dispute' ||
        status == 'Controlling' ||
        status == 'Cancelled'
      ) {
        return 'warning'
      }
      if (
        status == 'Refused' ||
        status == 'Refunded' ||
        status == 'ChargeBack' ||
        status == 'Fail' ||
        status == 'PayFail'
      ) {
        return 'danger'
      }
      return 'info'
    },
    fetchDetails (itemId) {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      localStorage.setItem('tid', itemId)
      this.getOrderInfoById(
        this.$route.params.tid || localStorage.getItem('tid')
      )
    },
    // 设置buyer移动端的宽度
    hideBuyerTd (item) {
      if (item === 'MUID') {
        return true
      } else {
        return true
      }
    },
    //  增加详情页面
    getVerticalTabTd (key, item, str, noId, i) {
      if (str === 'device') {
        return `<b class="${this.verticalTitle} device">${this.translateDetailLabel(key)}</b>${item}`
      } else if (str === 'buyer') {
        let mywidth = noId % 2 === 1 ? '120px' : '80px'
        // if(item === 'MUID') {
        //   return;
        // }
        return `<b class="${this.verticalTitle} buyer" style="width:${mywidth}">${this.translateDetailLabel(item)}</b> ${key}`
      } else if (str === 'merchant') {
        return `<b class="${this.verticalTitle} merchant">${this.translateDetailLabel(key)}</b> ${item}`
      } else if (!str) {
        return `<b class="${this.verticalTitle} mgr">${this.translateDetailLabel(item)}</b> ${key}`
      }
    },
    translateDetailLabel (label) {
      return mapDetailLabel(this, label)
    },

    isFormFieldValid (field) {
      let isValid = false
      if (this.formFields[field]) {
        isValid =
          this.formFields[field].validated && this.formFields[field].valid
      }
      return isValid
    },
    // 检查支付方式是否可以退款 - 是否显示退款按钮
    checkCanRefund (method) {
      var refundChannels = [
        // 信用卡
        'CreditCard',
        'ApplePay',
        'GooglePay',
        'Omannet',
        'Mada',
        'Uzum',
        'TPay',
        'Masary',
        'Aman',
        'Fawry',
        'STCPAY',
        'BCI',
        'PayU',
        'PPRO',
        'QRIS',
        'SINPEMovil',
        'MeezaQR',
        'UPI',
        'Nequi',
        'Khipu',
        'DirectDebit',
        'RecurringPIX',
        'Konbini',
        'PIXParaguay',
        'Troy',
        'Atome',
        'NetBanking',
        'PayPay',
        'VirtualAccount',
        'BlikOneClick',
        'MobileWallet',
        'RecurringSBP',
        'MobileBanking',

        'BankTransfer',
        'Wallet',
        'Boleto',
        // "Cash",
        'DebitCard',
        'DepositExpress',
        'Lottery',
        'OXXO',
        'OXXOpay',
        'OXXOPay',
        'PIX',
        'Pix',
        'RecurringCreditCard',
        'SPEI',
        'Crypto',
        'Trustly',
        'Giropay',
        // 'OpenFinance',
        'Paysafecard',
        'Multibanco',
        'Payconiq',
        'RecurringWallet',
        'BLIK',
        'SberPay',
        'SBP',
        'QRCode',
        'Kiosk',
        'WebPay',
        'DiscoverCard',
        'PromptPay',
        'PIXAutomatic',

        // * Luxtak *
        'PIXUruguay',
        'MOBILEMONEY',
        'BLIKPayLater',
        'MobileBanking',
      ]
      if (refundChannels.includes(method)) {
        return true
      }
      return false
    },
    // 检查支付方式是否可以接口退款
    checkAutomaticRefund (method) {
      var refundChannels = [
        // 信用卡
        'CreditCard',
        'ApplePay',
        'GooglePay',
        'Omannet',
        'Mada',
        'Uzum',
        'TPay',
        'Masary',
        'Aman',
        'Fawry',
        'STCPAY',
        'BCI',
        'PayU',
        'PPRO',
        'QRIS',
        'SINPEMovil',
        'MeezaQR',
        'UPI',
        'Nequi',
        'Khipu',
        'DirectDebit',
        'RecurringPIX',
        'Konbini',
        'PIXParaguay',
        'Troy',
        'Atome',
        'NetBanking',
        'PayPay',
        'VirtualAccount',
        'BlikOneClick',
        'MobileWallet',
        'RecurringSBP',
        'MobileBanking',

        'BankTransfer',
        'Wallet',
        'Trustly',
        'Giropay',
        // 'OpenFinance',
        'Paysafecard',
        'Multibanco',
        'Payconiq',
        'RecurringWallet',
        'BLIK',
        'SberPay',
        'SBP',
        'QRCode',
        'Kiosk',
        'WebPay',
        'DiscoverCard',
        'PromptPay',
        'PIXAutomatic',

        // * Luxtak *
        'PIXUruguay',
        'MOBILEMONEY',
        'BLIKPayLater',
        'MobileBanking',
      ]
      if (refundChannels.includes(method)) {
        if (this.speiFlag) {
          this.dispalyOtherFg = false
          return true
        } else {
          return true
        }
      }
      return false
    },
    // 检查支付方式是否可以人工退款 - 禁用点击refund没有反应 - // 检查支付方式是否需要展示单选项
    checkManualRefund (method) {
      var refundChannels = [
        'Boleto',
        // "BankTransfer",
        // "Cash",
        'DebitCard',
        'RecurringCreditCard',
        'PIX',
        'Pix',
        'DepositExpress',
        'Lottery',
        'OXXO',
        'OXXOpay',
        'OXXOPay',
        'SPEI',
        'Crypto'
      ]
      if (refundChannels.includes(method)) {
        if (this.speiFlag) {
          this.dispalyOtherFg = false
          return true
        } else {
          // this.checkboxOption = true;
          // this.dispalyOtherFg = true;
          return true
        }
      }
      return false
    },
    // 检查支付方式是否可以用SPEI完成退款
    checkCanSpeiRefund (method, paymentInfo) {
      var refundChannels = [
        // "Cash",
        'OXXO',
        'OXXOpay',
        'OXXOPay',
        'SPEI',
      ]
      // method=spei ，provider包含vpago和etpay字符的（不区分大小写）
      const methodToLower = method.toLocaleLowerCase()
      const providerToLower = paymentInfo && paymentInfo.provider ? paymentInfo.provider.toLocaleLowerCase() : ''
      if (!!paymentInfo && methodToLower === 'spei' && (providerToLower.includes('vpago') || providerToLower.includes('etpay'))) {
        return false
      }

      if (refundChannels.includes(method)) {
        return true
      }
      return false
    },
    // 检查支付方式是否需要展示单选项
    showCheckboxRefund (method) {
      var refundChannels = [
        // "BankTransfer",
        'DebitCard',
        'RecurringCreditCard',
        'PIX',
        'Pix',

        'SPEI',
      ]
      if (refundChannels.includes(method)) {
        return false
      }
      return true
    },
    showMediumModal () {
      this.$validator.reset()
      // this.refundMount = this.successfulEmail = this.refundExplain = this.single = this.userPass = ''
      this.refundAmount = this.paymentOrderData.detail.trans_base.order_amount || ''

      this.single =
      this.userPass =
      this.username =
      this.cpfNO =
      this.agency =
      this.selBank =
      this.accountType =
      this.bankAccountNumberFirst =
      this.bankAccountNumberLast =
      this.clabe =
      this.bankCode =
      this.documentId =
      this.documentType =
      this.documentName =
        ''
      this.selectedBank = {}
      this.selectedDocumentType = {}
      // 重置为false
      this.checkboxOption = false
      const that = this
      if (that.checkAutomaticRefund(that.detailInfo[0][3])) {
        that.checkboxOption = false
        that.$refs.mediumModal.open()
        that.$refs.mediumModal.style = ''
        // 限制拒绝退款的调用频率
        var callFrequency2Refund = {
          orderId: that.detailInfo[0][0],
          dataTime: new Date().getTime(), // 每1分钟才能重发
          countCk: 0,
        }
        that.$refs.mediumModal.ok = (callFrequency2Refund) => {
          let validateAutomaticRefundParams = {}
          if (that.detailInfo[0][3] === 'SBP' || that.detailInfo[0][3] === 'SberPay') {
            validateAutomaticRefundParams = {}
          } else {
            validateAutomaticRefundParams = {
              refundAmount: that.refundAmount,
              successfulEmail: that.successfulEmail,
              refundExplain: that.refundExplain,
              userPass: that.userPass
            }
            if (that.isShowRefundPhoneNumber) {
              validateAutomaticRefundParams.refundTelephone = that.refundTelephone
            }
          }

          that.$validator.validateAll(validateAutomaticRefundParams).then(result => {
            if (result) {
              that.toSubmitRefundData(callFrequency2Refund)
            }
          })
        }
      } else if (that.checkManualRefund(that.detailInfo[0][3])) {
        // TODO
        that.$refs.mediumModal.open()
        that.$refs.mediumModal.style = ''
        // 限制拒绝退款的调用频率
        var callFrequency2Refund = {
          orderId: that.detailInfo[0][0],
          dataTime: new Date().getTime(), // 每1分钟才能重发
          countCk: 0,
        }
        that.$refs.mediumModal.ok = (callFrequency2Refund) => {
          const validateManualRefundParams = {
            refundAmount: that.refundAmount,
            successfulEmail: that.successfulEmail,
            refundExplain: that.refundExplain,
            userPass: that.userPass
          }
          if (that.isShowRefundPhoneNumber) {
            validateManualRefundParams.refundTelephone = that.refundTelephone
          }
          that.$validator.validateAll(validateManualRefundParams).then(result => {
            if (result) {
              that.toSubmitRefundData(callFrequency2Refund, that.checkboxOption)
            }
          })
        }
      } else {

      }
    },
    showModalFillOrder () {
      this.$validator.reset()
      this.userPass = ''
      this.fillStatus = ''
      this.selectedStatus = {}
      if (
        this.detailInfo[1][2] === 'Match Status'
      ) {
        this.$refs.fillOrderModal.open()
        this.$refs.fillOrderModal.style = ''
        // 限制拒绝退款的调用频率
        var requestFrequencyLimit = {
          orderId: this.detailInfo[0][0],
          dataTime: new Date().getTime(), //  每1分钟才能重发
          countCk: 0,
        }
        const that = this
        this.$refs.fillOrderModal.ok = (requestFrequencyLimit) => {
          this.$validator.validateAll({
            orderStatus: that.fillStatus,
            userPass: that.userPass
          }).then(result => {
            if (result) {
              that.commitFillOrderInfo(requestFrequencyLimit)
            }
          })
        }
      } else {

      }
    },
    resizeLabel (e) {
      e.currentTarget.style.paddingTop = '5px'
    },
    focusLabel (e) {
      e.currentTarget.style.paddingTop = '18px'
    },
    popCreateOrderWin () {
      // // 弹出新标签页打开新订单支付页面，需要后台返回订单地址
      // let routes = this.$router.resolve({ name: "createOrder" });
      // window.open(routes.href, "_blank");
      this.$refs['create-order-component'].paymentLink.country = ''
      this.$refs['create-order-component'].paymentLink.currency = ''
      this.$refs['create-order-component'].countryCurrencyData = []
      this.$refs['create-order-component'].$validator.reset()
      this.$refs['create-order-component'].$refs['create-order-modal'].open()
    },
    createNewPayment () {
      this.searchOrder()
      this.popCreateOrderWin()
    },
    // 退款confirm 点击事件
    toSubmitRefundData (callBkObj, others) {
      if (this.refundCanDo === false) {
        return
      }
      if (!this.refundAmount) {
        return
      }
      // if (!this.successfulEmail) {
      //   return;
      // }
      if (!this.refundExplain) {
        return
      }
      if (!this.userPass) {
        return
      }
      // 其他现金支付提交
      if (others) {
        if (this.dispalyOtherFg) {
          if (!this.username) {
            return
          }
          if (!this.cpfNO) {
            return
          }
          if (!this.agency) {
            return
          }
          if (!this.selBank) {
            return
          }
          if (!this.accountType) {
            return
          }
          if (!this.bankAccountNumberFirst) {
            return
          }
          if (!this.bankAccountNumberLast) {
            return
          }
        } else {
          this.username =
            this.cpfNO =
            this.agency =
            this.selBank =
            this.accountType =
            this.bankAccountNumberFirst =
            this.bankAccountNumberLast =
              ''
        }
      } else {
        if (this.speiFlag) {
          if (!this.bankCode) {
            return
          }
          if (!this.clabe) {
            return
          }
        }
      }
      this.commitRefundInfo(callBkObj)
    },

    // 获取订单信息
    getOrderInfoById (tid) {
      let token = localStorage.getItem('Authorization')
      this.$set(this.depositUpload, 'uploadUrl', '')
      request({
        method: 'post',
        url: `api/dashboard/order/queryById?tid=${tid}&access_token=${token}`,
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((res) => {
          // 清空历史列表
          this.statusHistoryInfo.splice(0, this.statusHistoryInfo.length)
          if (res.status === 200) {
            let orderData = res.data
            if (orderData.code === '10000') {
              this.dialogTableVisible = true
              orderData = orderData.data
              if (orderData.voucher) {
                this.$set(
                  this.depositUpload,
                  'uploadUrl',
                  orderData.voucher.uploadUrl
                )
                if (orderData.voucher.paymentVoucher) {
                  this.$set(this.payVouchers, 0, {
                    name: 'Payment Voucher',
                    time: this.dateFormat(
                      orderData.voucher.paymentVoucher.time * 1000
                    ),
                    url: orderData.voucher.paymentVoucher.url,
                  })
                } else {
                  this.$set(this.payVouchers, 0, {
                    name: 'Payment Voucher',
                    time: 'N/A',
                    url: '',
                  })
                }

                if (orderData.voucher.personalId) {
                  this.$set(this.payVouchers, 1, {
                    name: 'Personal I.D.',
                    time: this.dateFormat(
                      orderData.voucher.personalId.time * 1000
                    ),
                    url: orderData.voucher.personalId.url,
                  })
                } else {
                  this.$set(this.payVouchers, 1, {
                    name: 'Personal I.D.',
                    time: 'N/A',
                    url: '',
                  })
                }

                if (orderData.voucher.addrProof) {
                  this.$set(this.payVouchers, 2, {
                    name: 'Proof of Address',
                    time: this.dateFormat(
                      orderData.voucher.addrProof.time * 1000
                    ),
                    url: orderData.voucher.addrProof.url,
                  })
                } else {
                  this.$set(this.payVouchers, 2, {
                    name: 'Proof of Address',
                    time: 'N/A',
                    url: '',
                  })
                }
              }
              const transBase = orderData.detail.trans_base
              this.detailInfo[0][0] = orderData.detail.trade_no
                ? orderData.detail.trade_no
                : 'N/A'
              this.detailInfo[0][1] =
                transBase.order_currency &&
                transBase.order_amount
                  ? `${transBase.order_currency} ${transBase.order_amount}`
                  : 'N/A'
              this.isPartialPay = transBase.is_partial_pay
              if (this.isPartialPay) {
                this.detailInfo[0][2] = transBase.order_currency && transBase.received_order_amount
                  ? `${transBase.order_currency} ${transBase.received_order_amount}`
                  : 'N/A'
                this.detailInfo[0][3] = transBase.subject
                  ? transBase.subject
                  : 'N/A'
                this.detailInfo[0][4] = transBase.method
                  ? transBase.method
                  : 'N/A'
                this.currentModalMethod = this.detailInfo[0][3]
                // this.checkManualRefund();
                this.detailInfo[0][5] = transBase.trade_status
                  ? transBase.trade_status
                  : 'N/A'
                this.detailInfo[0][6] = transBase.create_time
                  ? this.dateFormat(transBase.create_time)
                  : 'N/A'
                this.detailInfo[0][7] = (transBase.pay_resp_info && transBase.pay_resp_info.pay_channel_order) ? transBase.pay_resp_info.pay_channel_order : 'N/A'
              } else {
                this.detailInfo[0][2] = transBase.subject
                  ? transBase.subject
                  : 'N/A'
                this.detailInfo[0][3] = transBase.method
                  ? transBase.method
                  : 'N/A'
                this.currentModalMethod = this.detailInfo[0][3]
                // this.checkManualRefund();
                this.detailInfo[0][4] = transBase.trade_status
                  ? transBase.trade_status
                  : 'N/A'
                this.detailInfo[0][5] = transBase.create_time
                  ? this.dateFormat(transBase.create_time)
                  : 'N/A'
                this.detailInfo[0][6] = (transBase.pay_resp_info && transBase.pay_resp_info.pay_channel_order) ? transBase.pay_resp_info.pay_channel_order : 'N/A'
                // this.detailInfo[0][6] = orderData.trans_logs[0].log_callback_status + ' Callback' // 后台暂时没有
              }

              this.out_trade_no = orderData.detail.out_trade_no
              this.app_id = transBase.app_id
              // this.speiFlag = transBase.method == "SPEI" ? true : false;
              this.speiFlag = this.checkCanSpeiRefund(transBase.method, transBase.payment_info)
              // this.detailMethod = [
              //   "CreditCard",
              //   "Boleto",
              //   "Lottery",
              //   "DepositExpress",
              //   "PIX",
              //   "Pix",
              //   "Wallet",
              //   "SPEI",
              //   "RecurringCreditCard",
              //   // "BankTransfer",
              //   "DebitCard"
              // ].includes(transBase.method);
              this.canRefundMethod = this.checkCanRefund(orderData.detail.trans_base.method)
              this.detailInfo[1] =
                this.canRefundMethod === true &&
                (orderData.detail.trans_base.trade_status === 'Success' ||
                orderData.detail.trans_base.trade_status === 'PartialRefund')
                  ? ['Refund']
                  : ['']
              this.detailInfo[1][1] = 'Callback'
              this.detailInfo[1][2] = 'Match Status'

              for (let i = 0; i < orderData.detail.trans_logs.length; i++) {
                let statusHistory = []
                var refundMoney = orderData.detail.trans_logs[i].amount
                  ? orderData.detail.trans_logs[i].currency +
                    ' ' +
                    orderData.detail.trans_logs[i].amount
                  : orderData.detail.trans_base.order_amount
                    ? orderData.detail.trans_base.order_currency +
                    ' ' +
                    orderData.detail.trans_base.order_amount
                    : 'N/A'
                let newLogStatus = orderData.detail.trans_logs[i].log_status
                  ? orderData.detail.trans_logs[i].log_status
                  : 'N/A'
                statusHistory.push(newLogStatus)
                orderData.detail.trans_logs[i].newLogStatus = newLogStatus
                let newCreateTime = orderData.detail.trans_logs[i].create_time
                  ? this.dateFormat(
                    orderData.detail.trans_logs[i].create_time
                  )
                  : 'N/A'
                statusHistory.push(newCreateTime)
                orderData.detail.trans_logs[i].newCreateTime = newCreateTime
                statusHistory.push(refundMoney)
                orderData.detail.trans_logs[i].refundMoney = refundMoney
                let logCallbackStatus = orderData.detail.trans_logs[i].log_callback_status ? orderData.detail.trans_logs[i].log_callback_status
                  : 'N/A'
                statusHistory.push(logCallbackStatus)
                orderData.detail.trans_logs[i].logCallbackStatus = logCallbackStatus
                // if (orderData.detail.trans_base.method.toLowerCase() === "pix" && orderData.detail.trans_logs[i].log_status === "Refunded") {
                //   statusHistory.push('Refunded');
                // } else {
                //   statusHistory.push('N/A');
                // }
                this.$set(this.statusHistoryInfo, i, statusHistory)
              }
              this.merchantInfo = {
                'App Name': orderData.detail.trans_base.app_name,
                'App ID': orderData.detail.trans_base.app_id,
                'Merchant Reference': orderData.detail.out_trade_no,
              }
              // this.refundAmount = orderData.detail.trans_base.order_amount;
              this.refundAmount = orderData.refundable_amount
              this.successfulEmail = orderData.detail.trans_base.user_info
                ? orderData.detail.trans_base.user_info.email
                : 'N/A' // 用户的邮箱
              this.refundExplain = this.detailInfo[0][2] // 拒绝的描述
              // 设置交易信息
              this.transactionInfo = []
              if (orderData.detail.trans_base) {
                if (orderData.detail.trans_base.processing_fee_detail) {
                  let processing_fee_detail = JSON.parse(
                    orderData.detail.trans_base.processing_fee_detail
                  )
                  this.transactionInfo.push(processing_fee_detail.feeName)
                  this.transactionInfo.push(processing_fee_detail.ext)
                  this.transactionInfo.push(processing_fee_detail.feeAmount)
                }
              }
              // 设置购买用户的信息
              this.buyerInfo = []
              if (orderData.detail.trans_base) {
                if (orderData.detail.trans_base.payment_info) {
                  var amountMoney = 'N/A'
                  var amountCurrency = ''
                  var payAmount = {
                    type: '',
                    number: '',
                  }
                  var payIdentify =
                    orderData.detail.trans_base.payment_info.identify
                  if (payIdentify) {
                    if (typeof payIdentify === 'string') {
                      amountCurrency =
                        orderData.detail.trans_base.payment_info.currency
                      if (payIdentify.length <= 12) {
                        payAmount = {
                          type: 'cpf',
                          number: payIdentify,
                        }
                      } else if (payIdentify.length > 13) {
                        payAmount = {
                          type: 'cnpj',
                          number: payIdentify,
                        }
                      }
                    } else if (
                      Object.prototype.toString.call(payIdentify) ===
                      '[object Object]'
                    ) {
                      payAmount = {
                        type: payIdentify.type,
                        number: payIdentify.number,
                      }
                    }
                  }
                  this.buyerInfo.push({
                    NAME:
                      orderData.detail.trans_base.payment_info.buyer_name ||
                      'N/A',
                    'CPF/CNPJ': payIdentify && payIdentify.type
                      ? formatUserCredentials(payAmount.type, payAmount.number)
                      : 'N/A',
                  })
                  this.buyerInfo.push({
                    MUID:
                      (orderData.detail.trans_base.user_info
                        ? orderData.detail.trans_base.user_info.buyer_id
                        : 'N/A') || 'N/A',
                    Email:
                      orderData.detail.trans_base.payment_info.email || 'N/A',
                  })
                  let cardNo = {}
                  if (orderData.detail.trans_base.method === 'CreditCard') {
                    cardNo = { 'Card NO.': orderData.card_info.first_six_digits ? `${orderData.card_info.first_six_digits}****${orderData.card_info.last_four_digits}` : 'N/A' }
                  }
                  this.buyerInfo.push({
                    'Phone Number':
                      orderData.detail.trans_base.payment_info.phone || 'N/A',
                    ...cardNo
                  })
                } else {
                  this.buyerInfo.push({
                    NAME: 'N/A',
                    'CPF/CNPJ': 'N/A',
                  })
                  this.buyerInfo.push({
                    MUID:
                      (orderData.detail.trans_base.user_info
                        ? orderData.detail.trans_base.user_info.buyer_id
                        : 'N/A') || 'N/A',
                    Email: 'N/A',
                  })
                  let cardNo = {}
                  if (orderData.detail.trans_base.method === 'CreditCard') {
                    cardNo = { 'Card NO.': orderData.card_info.first_six_digits ? `${orderData.card_info.first_six_digits}****${orderData.card_info.last_four_digits}` : 'N/A' }
                  }
                  this.buyerInfo.push({
                    'Phone Number': 'N/A',
                    ...cardNo
                  })
                }
                if (orderData.detail) {
                  if (orderData.detail.trans_logs) {
                    if (
                      orderData.detail.trans_logs[0].log_status === 'Refused'
                    ) {
                      this.refusedFg = true
                      if (orderData.risk) {
                        this.refusedInfo = orderData.risk.refuseInfo || 'N/A'
                      } else {
                        this.refusedInfo = 'N/A'
                      }
                      if (orderData.refusal) {
                        this.refusalCode = orderData.refusal.code
                        this.refusalMsg = orderData.refusal.message
                      }
                    } else {
                      this.refusedFg = false
                    }
                  }
                }
              }

              this.paymentOrderData = orderData

              // 隐藏loading
              setTimeout(() => {
                this.loading.close()
              }, 200)
            } else {
              this.paymentOrderData = {}
              // 隐藏loading
              setTimeout(() => {
                this.loading.close()
              }, 200)
              this.$message({
                message: 'System error, please refresh and try again!',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          this.paymentOrderData = {}
          // 隐藏loading
          setTimeout(() => {
            this.loading.close()
          }, 200)
          console.log(err)
        })
    },
    downloadAttachment (obj, e) {
      // 跨域问题，不能直接下载
      // downloadImage(obj.url, obj.name.replace(" ", "_") + '_' + Math.floor((Math.random()*10000000)+1));
      if (event) {
        event.preventDefault()
      }
      let routes = this.$router.resolve({ name: 'downloadDoc' })
      window.open(routes.href + '?downLoadUrl=' + obj.url, '_blank')
    },

    isBankVaild (field) {
      let isValid = false
      if (this.bankStatus) {
        isValid = true
      }
      return isValid
    },
    isAccountVaild (field) {
      let isValid = false
      if (this.aTypeStatus) {
        isValid = true
      }
      return isValid
    },
    initRefund () {
      this.refundAmount = ''
      this.refundTelephone = ''
      this.successfulEmail = ''
      this.refundExplain = ''
      this.loading.close()
    },
    // getRefundFormDataParam () {
    //   let trade_no = this.$route.params.tid || localStorage.getItem("tid");
    //   const param = new FormData();
    //   param.append("trade_no", trade_no);
    //   param.append("amount", this.refundAmount);
    //   if (this.detailInfo[0][3] !== 'SBP' && this.detailInfo[0][3] !== 'SberPay') {
    //     param.append("email", this.successfulEmail);
    //   }
    //   param.append("password", this.userPass);
    //   param.append("desc", this.refundExplain);
    //   if (this.dispalyOtherFg) {
    //     param.append("identification_number", this.cpfNO.replace(".", "").replace("-", ""));
    //     param.append("username", this.username);
    //     let bankInfo = {
    //       bank_id: this.selBank.value,
    //       bank_name: this.selBank.description,
    //       agency: this.agency,
    //       type: "" + this.accountType.id,
    //       number:
    //         this.bankAccountNumberFirst.replace(/\s/g, "") +
    //         "-" +
    //         this.bankAccountNumberLast,
    //     };
    //     param.append("bank_info", JSON.stringify(bankInfo));
    //   }
    //   if (this.speiFlag) {
    //     param.append("identification_number", this.documentId.replace(".", "").replace("-", ""));
    //     param.append("identification_type", this.selectedDocumentType.value);
    //     param.append("username", this.documentName);
    //     let bankInfo = {
    //       bank_id: this.selectedBank.value,
    //       bank_name: this.selectedBank.label,
    //       number: this.clabe,
    //     }
    //     param.append("bank_info", JSON.stringify(bankInfo));
    //   }
    //   // 调试银行的信息 TODO
    //   // if (this.single.length === 1) {
    //   //   param.append('file', this.single[0])
    //   // }
    //   return param
    // },
    getRefundParams () {
      let trade_no = this.$route.params.tid || localStorage.getItem('tid')
      const params = {}
      params.trade_no = trade_no
      params.amount = this.refundAmount
      if (this.isShowRefundEmail) {
        params.email = this.successfulEmail
      }
      params.password = this.userPass
      params.desc = this.refundExplain
      if (this.dispalyOtherFg) {
        params.identification_number = this.cpfNO.replace('.', '').replace('-', '')
        params.username = this.username
        let bankInfo = {
          bank_id: this.selBank.value,
          bank_name: this.selBank.description,
          agency: this.agency,
          type: '' + this.accountType.id,
          number:
            this.bankAccountNumberFirst.replace(/\s/g, '') +
            '-' +
            this.bankAccountNumberLast,
        }
        params.bank_info = JSON.stringify(bankInfo)
      }
      if (this.speiFlag) {
        params.identification_number = this.documentId.replace('.', '').replace('-', '')
        params.identification_type = this.selectedDocumentType.value
        params.username = this.documentName
        let bankInfo = {
          bank_id: this.selectedBank.value,
          bank_name: this.selectedBank.label,
          number: this.clabe,
          // document_id: this.documentId,
          // document_type: this.selectedDocumentType.value,
          // document_name: this.documentName
        }
        params.bank_info = JSON.stringify(bankInfo)
      }
      if (this.isShowRefundPhoneNumber) {
        params.phone = this.refundTelephone
      }
      return params
    },
    // 提交退款相关的信息
    commitRefundInfo (ckObj) {
      let trade_no = this.$route.params.tid || localStorage.getItem('tid')
      if (trade_no === ckObj.orderId && ckObj.countCk > 1) {
        this.refundCanDo = false
        return
      }
      let token = localStorage.getItem('Authorization')
      const params = this.getRefundParams()
      // this.$refs.mediumModal.close();
      this.loadingFullScreen('refunding', 'Refunding', 'fa fa-hourglass-half')
      request({
        method: 'post',
        url: `api/dashboard/order/refund?access_token=${token}`,
        data: params,
        headers: {
          'access_token': token,
          'Content-Type': 'application/json'
          // 'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.refunding.close()
        ckObj.countCk++
        let code = res.data.code
        this.show = false
        if (code == '10000') {
          this.toastText = res.data.msg || 'Success!'
          if (res.data.data && res.data.data.subMsg) {
            this.toastText += `, ${res.data.data.subMsg}`
          }
          this.launchToast()
          this.dialogTableVisible = false
          setTimeout(function () {
            this.loadingFullScreen('searching', 'Searching', 'fa fa-hourglass-half')
            this.orderData()
          }, 20)
          this.$refs.mediumModal.close()
        } else {
          this.toastText = ''
          if (res.data.sub_msg) {
            this.toastText = `${res.data.sub_msg}`
          } else {
            this.toastText = `${res.data.msg}`
          }
          this.launchToast()
        }
      }).catch(err => {
        this.refunding.close()
        this.toastText = err.msg || 'Business Failed'
        this.launchToast()
      })
    },
    commitFillOrderInfo (ckObj) {
      let trade_no = this.$route.params.tid || localStorage.getItem('tid')
      if (trade_no === ckObj.orderId && ckObj.countCk > 1) {
        return
      }
      let token = localStorage.getItem('Authorization')
      const param = new FormData()
      param.append('app_id', this.app_id)
      param.append('out_trade_no', this.out_trade_no)
      param.append('trade_status', this.selectedStatus.value)
      param.append('password', this.userPass)
      this.loadingFullScreen('matchStatusLoading', 'Loading', 'fa fa-hourglass-half')
      request({
        method: 'post',
        url: `api/dashboard/order/match-status?access_token=${token}`,
        // url: `api/dashboard/order/fill-order?access_token=${token}`,
        data: param,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.matchStatusLoading.close()
        ckObj.countCk++
        let code = res.data.code
        this.show = false
        if (code == 10000) {
          this.$refs.fillOrderModal.close()
          this.toastText = res.data.msg || 'Success!'
          this.dialogTableVisible = false
          this.launchToast()
          setTimeout(function () {
            this.loadingFullScreen('loading', 'Loading', 'fa fa-hourglass-half')
            this.orderData()
          }, 20)
        } else {
          this.toastText = res.data.sub_msg || 'Business Failed'
          this.launchToast()
        }
      }).catch(err => {
        this.toastText = err.msg || 'Business Failed'
        this.launchToast()
      })
    },
    callbackOrderStatus () {
      this.isLoading = true
      let token = localStorage.getItem('Authorization')
      let out_trade_no = this.out_trade_no
      let app_id = this.app_id
      request({
        method: 'post',
        url: `api/dashboard/order/callback?access_token=${token}&app_id=${app_id}&out_trade_no=${out_trade_no}`,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        let code = res.data.code
        if (code == 10000) {
          this.toastText = res.data.msg || 'Success!'
          this.launchToast()
          setTimeout(() => {
            this.loadingFullScreen('searching', 'Searching', 'fa fa-hourglass-half')
            this.orderData()
          }, 20)
        } else {
          this.toastText = res.data.msg
          this.launchToast()
        }
        this.isLoading = false
      }).catch(err => {
        this.toastText = err.msg
        this.launchToast()
        this.isLoading = false
      })
    },

    launchToast () {
      this.isToastContentPresent = true
      this.showToast(this.toastText, {
        icon: this.toastIcon,
        position: this.toastPosition,
        duration: this.toastDuration,
        fullWidth: this.isToastFullWidth
      })
      this.isToastContentPresent = false
    },
    downloadDelbankPdfSuccess (item) {
      const { channel_info } = this.paymentOrderData
      if (!channel_info) { return }
      const e2eId = channel_info.channel_order_id
      window.open(`https://api.delbank.com.br/baas/api/v1/pix/${e2eId}/proof`)
    },
    getRefundOrder (item) {
      let refundOrder = ''
      const baseInfo = this.paymentOrderData.detail.trans_base
      const { pay_resp_info: payRespInfo } = baseInfo
      if (baseInfo.trade_status.toLowerCase() === 'refused' && !!payRespInfo) {
        refundOrder = payRespInfo.refund_order
      } else if (item && (baseInfo.trade_status.toLowerCase() === 'refunded' || baseInfo.trade_status.toLowerCase() === 'partialrefunded')) {
        refundOrder = item.refund_channel_order ? item.refund_channel_order : ''
      }
      return refundOrder
    },
    downloadDelbankPdfRefund (item) {
      const e2eId = this.getRefundOrder(item)
      window.open(`https://api.delbank.com.br/baas/api/v1/pix/${e2eId}/proof`)
    },
    handleDownloadPdf (item) {
      this.loadingFullScreen('pdfLoading', 'Loading', 'fa fa-hourglass-half')
      const { actual_currency, actual_amount, refund_channel_order, update_time } = item
      const baseInfo = this.paymentOrderData.detail.trans_base
      const { payer = {} } = baseInfo
      const { identification = {}, username } = payer
      const payerDetails = {
        'MP': { from: 'MP', institution: 'MERCADO PAGO', cnpj: '23.010.551/0001-31' },
        'BS2': { from: 'BS2', institution: 'BCO BS2 S.A.', cnpj: '23.010.551/0001-31' },
        'BTG': { from: 'BTG', institution: 'BANCO BTG PACTUAL S.A.', cnpj: '23.010.551/0001-31' },
        'Genial': { from: 'Genial', institution: 'BANCO GENIAL', cnpj: '23.010.551/0001-31' },
        'Delbank': { from: 'Delbank', institution: 'DELCRED SCD S.A.', cnpj: '23.010.551/0001-31' },
        'Fastcash': { from: 'Fastcash', institution: 'MICROCASH SCMEPP', cnpj: '23.010.551/0001-31' },
        'StarkBank': { from: 'StarkBank', institution: `${process.env.VUE_APP_NAME} intermediacao e Agenciamento de Negocios Ltda`, cnpj: '23.010.551/0001-31' }
      }
      this.refundVoucher = {
        actualCurrency: actual_currency || '--',
        actualAmount: actual_amount || '--',
        transactionId: this.paymentOrderData.detail.trade_no || '--',
        paymentId: refund_channel_order || '--',
        dateAndTime: update_time || '--',
        name: username || '--',
        bank: 'N/A',
        accountType: 'N/A',
        accountNo: 'N/A',
        from: '--',
        cnpj: '--',
        institution: '--'
      }
      if (identification && identification.number && identification.type) {
        this.refundVoucher.documentType = identification.type
        this.refundVoucher.documentNumber = identification.number
      }
      if (baseInfo.payment_info && baseInfo.payment_info.provider) {
        const provider = baseInfo.payment_info.provider
        if (payerDetails[provider]) {
          this.refundVoucher.from = payerDetails[provider].from
          this.refundVoucher.cnpj = payerDetails[provider].cnpj
          this.refundVoucher.institution = payerDetails[provider].institution
        }
      }
      // console.log('this.refundVoucher -> ', JSON.stringify(this.refundVoucher))
      const that = this
      let pdfDom = null
      this.$nextTick(async () => {
        pdfDom = that.$refs['render-pdf-ref'].$refs['pdf-ref']
        pdfDom.style.display = 'block'
        await downloadPDF(pdfDom, 'Refund information').catch(() => { })
        pdfDom.style.display = 'none'
        this.pdfLoading.close()
      })
    }
  },
  components: {
    TableFiledsSettings,
    Pagination,
    Scrollbar, //  增加详情页面
    CreateOrder,
    RenderPdfDom
  },
}
</script>
<style>
@media only screen and (max-width: 750px) {
  .el-pagination.is-background {
    display: flex;
    flex-wrap: wrap;
    height: 70px;
  }
  .el-pagination__total {
    order: 1;
    margin-right: 20px !important;
    letter-spacing: 2px;
  }
  .btn-prev {
    width: 20px;
    order: 2;
    margin-right: 10px !important;
  }
  .el-pager {
    order: 4;
  }
  .btn-next {
    width: 20px;
    order: 3;
  }
}

.fill-order-modal .modal-dialog {
  @media only screen and (min-width: 750px) {
    width: 400px !important;
  }
}
</style>

<style lang="scss" scoped>
@import "./PaymentOrder/PaymentOrder.scss";
.action-color-1 {
  color: $action-color;
  cursor:pointer;
}
</style>
